import { gql } from "@apollo/client";

export const GET_BUSINESS_LIST = gql`
  query getBusinessList(
    $companyId: Int = null
    $companyName: String
    $franchiseeId: Int = null
    $statusIds: String!
    $categoryIds: String!
    $provinceIds: String!
    $cityIds: String!
    $suburbIds: String!
    $size: Int = null
    $page: Int = null
  ) {
    getBusinessList(
      companyId: $companyId
      companyName: $companyName
      franchiseeId: $franchiseeId
      statusIds: $statusIds
      categoryIds: $categoryIds
      provinceIds: $provinceIds
      cityIds: $cityIds
      suburbIds: $suburbIds
      page: $page
      size: $size
    ) {
      count
      currentPage
      message
      nextPage
      prevPage
      success
      totalPages
      result {
        companyId
        companyName
        joinDate
        logoPath
        compProvinceName
        compCityName
        compSuburb
        compStreetAddress
        compCategory
        compDescription
        compHelpDeskNumber
        compEmailId
        latitude
        longitude
        ratingScore
      }
    }
  }
`;
